module.exports = __webpack_public_path__ + "static/media/vernal1.7de4fbf8.jpg";